import React, { useEffect, useState } from 'react'
import '../../styles/PlacedStudent.css'
import { AluminiSpeakWebSite } from '../index'
import { getPlacedStudents } from '../../services/getAllApi';
// import { Professor } from '../../assets/index'

const PlacedStudent = () => {

  const [columns, setColumns] = useState(4);
  const [studentData, setStudentData] = useState([])

  const calculateColumns = () => {
    const width = window.innerWidth;
    if (width >= 1200) return 4;
    if (width >= 768 && width < 1200) return 3;
    if (width >= 480 && width < 768) return 2;
    return 1;
  };

  useEffect(() => {

    getPlacedStudents()
      .then((res) =>{ 
        if(res.status === 200){
          setStudentData(res.data.slice().reverse())
        }
         }
    )

    const handleResize = () => setColumns(calculateColumns());
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
 
  
  return (
    <>

      <div className="placed-students-container">
        <div className="placed-students">
          <h1 className="ps_title">Placed Students</h1>
          <p className="ps_subtitle">
            We work end to end with the candidates for starting a career in finance
            by giving them access to our well-knit corporate network. Few of them
            are mentioned below.
          </p>
          <div className="arrow_container">
            <div className="horizonal_line"></div>
            <div className="arrow-line">
              {Array.from({ length: columns }).map((_, index) => (
                <div key={index} className="arrow">▼</div>
              ))}
            </div>
          </div>
          <div className="profile-grid">
            {studentData && studentData.length > 0 ?
              studentData.map((student, index) => (
                <div className="profile-card">
                  <img src={`${"https://console.fbsedu.in/storage/app"}/${student.student_photo}`} alt={`${student.student_name}`} className="profile-image" />
                  <div className="border_line"></div>
                  <h3 className="profile-name">{student.student_name}</h3>
                  <div className="company-section">
                    <img src={`${"https://console.fbsedu.in/storage/app"}/${student.company_logo}`} alt={`${student.company_logo}`} className="company-logo" />
                  </div>
                </div>
              )) :
              "No Data found for Placed Students"
            }
          </div>
        </div>
      </div>
      <AluminiSpeakWebSite />

    </>
  )
}

export default PlacedStudent